module.exports = __webpack_public_path__ + "assets/img/404.df9fe15a.png";